module.exports = __webpack_public_path__ + "img/active-archie.f226317a.svg";